import React from "react";
import AboutStart from "../components/AboutStart";
import FromIdea from "../components/FromIdea";
import CulturePrinciples from "../components/CulturePrinciples";
import WorkTogetherCta from "../components/WorkTogetherCta";
import ReadySolutions from "../components/ReadySolutions";
import Video from "../components/VideoAbout";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SiteHeader from "../components/SiteHeader";

import { useTranslation } from 'react-i18next';
import i18n from "../i18n";


export default function About() {
    const { t } = useTranslation();
    const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
    return(
        <div id="about-page">
            <SiteHeader
                pageLinks={[
                    { label: t('$AboutUs'), href: '/about' }
                ]}
                cta={[{ label: t('$Login'), to: `/login`},
                      { label: t('$Reg', 'Зарегистрироваться'), to: `/register` }
                ]}
                mode="default"
            />
            <div>
                <AboutStart />
            </div>
            <div>
                <FromIdea />
            </div>
            <CulturePrinciples />
            <ReadySolutions />
            <Video />
            <WorkTogetherCta/>
            <Footer />
        </div>
    );
}